import $ from 'jquery';
import config from '../config';
const URL_API = config.urlApi+'controllers/getTodayVisitors.controller.php';

export default function getTodayVisits(values){
    return $.ajax({
        data: values,
        url: URL_API,
        type: 'GET'
    })
}